export const FEATURE_FLAGS = {
  AGENT_BOTS: 'agent_bots',
  AGENT_MANAGEMENT: 'agent_management',
  ASSIGNMENT_V2: 'assignment_v2',
  ADVANCED_ASSIGNMENT: 'advanced_assignment',
  AUTO_RESOLVE_CONVERSATIONS: 'auto_resolve_conversations',
  AUTOMATIONS: 'automations',
  CAMPAIGNS: 'campaigns',
  WHATSAPP_CAMPAIGNS: 'whatsapp_campaign',
  CANNED_RESPONSES: 'canned_responses',
  CRM: 'crm',
  CUSTOM_ATTRIBUTES: 'custom_attributes',
  INBOX_MANAGEMENT: 'inbox_management',
  INTEGRATIONS: 'integrations',
  LABELS: 'labels',
  MACROS: 'macros',
  HELP_CENTER: 'help_center',
  REPORTS: 'reports',
  TEAM_MANAGEMENT: 'team_management',
  VOICE_RECORDER: 'voice_recorder',
  AUDIT_LOGS: 'audit_logs',
  INBOX_VIEW: 'inbox_view',
  SLA: 'sla',
  CHANNEL_EMAIL: 'channel_email',
  CHANNEL_FACEBOOK: 'channel_facebook',
  CHANNEL_WEBSITE: 'channel_website',
  CUSTOM_REPLY_DOMAIN: 'custom_reply_domain',
  CUSTOM_REPLY_EMAIL: 'custom_reply_email',
  DISABLE_BRANDING: 'disable_branding',
  EMAIL_CONTINUITY_ON_API_CHANNEL: 'email_continuity_on_api_channel',
  INBOUND_EMAILS: 'inbound_emails',
  IP_LOOKUP: 'ip_lookup',
  LINEAR: 'linear_integration',
  LUMERAI: 'ia',
  CUSTOM_ROLES: 'custom_roles',
  LUMERATEC_V4: 'lumeratec_v4',
  CHANNEL_INSTAGRAM: 'channel_instagram',
  CHANNEL_TIKTOK: 'channel_tiktok',
  CHANNEL_MERCADO_LIVRE: 'channel_mercado_livre',
  CHANNEL_VOICE: 'channel_voice',
  INSTAGRAM_ADVANCED_UI: 'instagram_advanced_ui',
  FACEBOOK_ADVANCED_UI: 'facebook_advanced_ui',
  TIKTOK_ADVANCED_UI: 'tiktok_advanced_ui',
  CONTACT_LUMERATEC_SUPPORT_TEAM: 'contact_lumeratec_support_team',
  LUMERAI_CUSTOM_TOOLS: 'custom_tools',
  LUMERAI_V2: 'ia',
  LUMERAI_TASKS: 'lumerai_tasks',
  LUMERAI_SUMMARIES: 'lumerai_summaries',
  LUMERAI_DOCUMENT_AUTO_SYNC: 'lumerai_document_auto_sync',
  SAML: 'saml',
  COMPANIES: 'companies',
  ADVANCED_SEARCH: 'advanced_search',
  CONVERSATION_REQUIRED_ATTRIBUTES: 'conversation_required_attributes',
  CONVERSATION_UNREAD_COUNTS: 'conversation_unread_counts',
  CALENDAR: 'calendar',
};

export const PREMIUM_FEATURES = [
  FEATURE_FLAGS.SLA,
  FEATURE_FLAGS.LUMERAI,
  FEATURE_FLAGS.LUMERAI_CUSTOM_TOOLS,
  FEATURE_FLAGS.CUSTOM_ROLES,
  FEATURE_FLAGS.AUDIT_LOGS,
  FEATURE_FLAGS.HELP_CENTER,
  FEATURE_FLAGS.SAML,
  FEATURE_FLAGS.CONVERSATION_REQUIRED_ATTRIBUTES,
  FEATURE_FLAGS.ADVANCED_ASSIGNMENT,
  FEATURE_FLAGS.INSTAGRAM_ADVANCED_UI,
  FEATURE_FLAGS.FACEBOOK_ADVANCED_UI,
  FEATURE_FLAGS.TIKTOK_ADVANCED_UI,
  FEATURE_FLAGS.CHANNEL_MERCADO_LIVRE,
  FEATURE_FLAGS.LUMERAI_SUMMARIES,
  FEATURE_FLAGS.CALENDAR,
];
